<ng-container *ngIf="name$ | async as name">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="name"></fgb-banner>
  </div>
</ng-container>

<div class="widget-mobile">
  <div class="pt-3 pt-lg-0">
    <fgb-account-nav></fgb-account-nav>
  </div>

  <div class="container mt-0 mt-lg-4">
    <div class="d-flex gap-3 flex-row">
      <div class="col-6 d-lg-block d-none">
        <h5 class="mb-3 mt-0 profile-title fw-light-bold font-page-heading">
          {{ 'accounts.member.card' | translate }}
        </h5>
        <fgb-member-card showSeating="true"></fgb-member-card>
      </div>

      <div class="col-12 col-lg-6 user-detail-container">
        <h5 class="mb-3 profile-title fw-light-bold font-page-heading">{{ 'accounts.member.details' | translate }}</h5>
        <fgb-account-details></fgb-account-details>
      </div>
    </div>
  </div>
</div>
